import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { FcPaid } from "react-icons/fc";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { BsCheck2Square } from "react-icons/bs";
import { useSelector } from "react-redux";
const getImage = (data) => {
  if (data?.pmg_plant?.id) {
    return data?.pmg_plant?.agronomyWikiUpdate?.image;
  }
  if (data?.pmg_accessory?.id) {
    return data?.pmg_accessory?.photo;
  }
};
const getProductName = (data) => {
  if (data?.pmg_plant?.id) {
    return data?.pmg_plant?.agronomyWikiUpdate?.name?.toUpperCase();
  }
  if (data?.pmg_accessory?.id) {
    return data?.pmg_accessory?.name.toUpperCase();
  }
};
const getSku = (data) => {
  if (data?.pmg_plant?.id) {
    return data?.pmg_plant?.plantSKU?.toUpperCase();
  }
  if (data?.pmg_accessory?.id) {
    return data?.pmg_accessory?.accSKU.toUpperCase();
  }
};

const getOrderStatus = (data) => {
  if (data?.status === "accepted") {
    return <span class="badge bg-green text-green-fg">ACCEPTED</span>;
  }
  return <span class="badge bg-red text-red-fg">PENDING</span>;
};
const FarmerOrderView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  let { id } = useParams();
  const navigate = useNavigate();
  let role = useSelector((store) => store?.login?.user);
  useEffect(() => {
    if (role && role.Role === process.env.REACT_APP_ROLE_CLIENT) {
      if (role.AdditionalRole !== "farmer partner") {
        navigate("/");
      }
    }
  }, [role]);
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/pmg/fa-orders/fa-order/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handelOrderAcceptance = (Id) => {
    performRequest("PATCH", `/pmg/fa-orders//accept-fa-order/${Id}`, {
      status: "accepted",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Order status updated successfully!");

          setRefresh(!refresh);
          navigate("/farm-plants-inventory");
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPaid className="fs-2  me-1" /> View Order
                </h2>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="table-responsive">
                  <table className="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specification</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <tr>
                          <td>Photo</td>
                          <td>
                            <img src={getImage(data)} width={100} />
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Order Id</td>
                          <td>
                            <b>{(data?.orderID || "N/A")?.toUpperCase()}</b>
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product</td>
                          <td>{getProductName(data)}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product SKU</td>
                          <td>
                            <b>{getSku(data)}</b>
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Order status</td>
                          <td>{getOrderStatus(data)}</td>
                        </tr>
                      )}
                      {/* {data && (
                        <tr>
                          <td>Payment details</td>
                          <td>
                            {(
                              data?.paymentDetails?.time || "N/A"
                            )?.toUpperCase()}
                          </td>
                        </tr>
                      )} */}
                      {data &&
                        (data?.orderType?.endsWith("to farmer") ? (
                          <tr>
                            <td>Order from</td>
                            <td>
                              {`${data?.user_model?.userName?.toUpperCase()} , ${data?.user_model?.permanentAddress?.toUpperCase()} `}{" "}
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td>Order To</td>
                            <td>
                              {`${data?.OrderToUser?.userName?.toUpperCase()} , ${data?.OrderToUser?.permanentAddress?.toUpperCase()} `}{" "}
                            </td>
                          </tr>
                        ))}

                      {data && (
                        <tr>
                          <td>Shipping Address</td>
                          <td>
                            {`${data?.shippingAddress?.address?.toUpperCase()} , ${data?.shippingAddress?.city?.toUpperCase()} , ${data?.shippingAddress?.state?.toUpperCase()} , ${data?.shippingAddress?.pincode?.toUpperCase()}`}{" "}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Quantity</td>
                          <td>{(data?.quantity || "N/A")?.toUpperCase()}</td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Total Amount</td>
                          <td>
                            ₹{(data?.totalAmount || "N/A")?.toUpperCase()}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    {/* <SimpleButton
                      buttonText="Edit Workforce"
                      href={`/client-employee-database/edit/${id}`}
                    /> */}
                    {data?.orderType?.endsWith("to farmer") && (
                      <button
                        className="btn mx-1 mt-2 btn-primary"
                        disabled={data?.status !== "pending"}
                        onClick={() => handelOrderAcceptance(data?.id)}
                      >
                        <BsCheck2Square className="fs-2 me-2" />
                        ACCEPT ORDER
                      </button>
                    )}
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FarmerOrderView;
